module.exports = __webpack_public_path__ + "img/7.0325fa5a.jpg";